export const UPGRADE_TOOLTIP_CONTENT = {
  landingPages: {
    title: "Landing Pages",
    description:
      "Easily create a cohesive, on-brand experience for your incoming applicants with customize-able landing pages.",
  },
  exitPages: {
    title: "Exit Pages",
    description:
      "Easily create a cohesive, on-brand experience for your incoming applicants with customize-able exit pages.",
  },
  emailTemplates: {
    title: "Email Templates",
    description:
      "Create custom emails for your candidates communications for any stage of your job.",
  },
  ratingSystems: {
    title: "Rating Systems",
    description:
      "Set up a custom rating system for your team to gather feedback in a centralized place for all you candidates.",
  },
  structuredInterviewing: {
    title: "Structured Interviewing",
    description:
      "Accelerate your hiring process with interviewing tools that are 3x faster than phone screens, 2x more predictive of success, and loved by 70% of candidates.",
  },
  develop: {
    title: "Develop",
    description:
      "Foster teamwork, collaboration, and communication with talent management tools designed to enhance team performance and empower employee growth.",
  },
};
